import { handleActions } from "redux-actions";
import createPromiseThunk from "lib/createPromiseThunk";
import * as api from "lib/api/myInfo";

const USER_INFO = "myinfo/USER_INFO"; // 회원정보
// const USER_INFO_PENDING = "myinfo/USER_INFO_PENDING";
const USER_INFO_SUCCESS = "myinfo/USER_INFO_SUCCESS";
const USER_INFO_PW_CONFIRM = "myinfo/USER_INFO_PW_CONFIRM"; // 회원정보 비밀번호확인

const MODIFY_INFO = "myinfo/MODIFY_INFO"; // 회원정보 수정
// const MODIFY_INFO_PENDING = "myinfo/USER_INFO_PENDING";
// const MODIFY_INFO_SUCCESS = "myinfo/USER_INFO_SUCCESS";

export const userInfoData = createPromiseThunk(USER_INFO, api.userInfo);
export const modifyInfoData = createPromiseThunk(
  MODIFY_INFO,
  api.userInfoModify
);
export const userInfoPwConfirm = createPromiseThunk(USER_INFO_PW_CONFIRM, api.pwConfirm);

const initialState = {
  data: null
};

export default handleActions(
  {
    // [USER_INFO_PENDING]: (state, { payload }) => ({
    //   ...state,
    //   data: null
    // }),
    [USER_INFO_SUCCESS]: (state, { payload }) => ({
      ...state,
      data: payload.data
    })
  },
  initialState
);
